<template>
  <v-form ref="form" v-model="valid" @submit.prevent="handleSubmit">
    <v-alert v-if="error" type="error" dense class="mb-4">{{ error }}</v-alert>

    <v-text-field
      v-model="values.name"
      label="Template Name *"
      :rules="[rules.required]"
      outlined
      dense
      class="mb-2"
      placeholder="e.g. June Campaign"
    />

    <v-text-field
      v-model="values.subject"
      label="Default Subject *"
      :rules="[rules.required]"
      outlined
      dense
      class="mb-2"
      placeholder="Email subject line (can be overridden when sending)"
    />

    <v-textarea
      v-model="values.description"
      label="Description"
      outlined
      dense
      rows="2"
      class="mb-2"
      placeholder="Internal notes about this template"
    />

    <v-textarea
      v-model="values.html_content"
      label="HTML Content *"
      :hint="'Use {{variable}} placeholders for dynamic content'"
      :rules="[rules.required]"
      outlined
      dense
      rows="14"
      class="mb-2"
      style="font-family: monospace"
      :placeholder="'<h1>Hello {{name}}</h1>'"
    />

    <v-checkbox v-model="values.active" label="Active (available for sending)" class="mt-0 mb-4" />

    <v-btn type="submit" color="primary" :loading="saving" :disabled="saving"> Save Template </v-btn>
  </v-form>
</template>

<script>
export default {
  name: 'TemplateForm',

  props: {
    defaultValues: {
      type: Object,
      default: () => ({}),
    },
    submitFn: {
      type: Function,
      required: true,
    },
  },

  data() {
    return {
      valid: false,
      saving: false,
      error: null,
      values: {
        name: this.defaultValues.name || '',
        subject: this.defaultValues.subject || '',
        description: this.defaultValues.description || '',
        html_content: this.defaultValues.html_content || '',
        active: this.defaultValues.active !== undefined ? this.defaultValues.active : true,
      },
      rules: {
        required: (v) => !!v || 'This field is required',
      },
    };
  },

  methods: {
    async handleSubmit() {
      if (!this.$refs.form.validate()) return;
      this.saving = true;
      this.error = null;
      try {
        await this.submitFn({ ...this.values });
      } catch (err) {
        this.error =
          (err.response && err.response.data && err.response.data.message) || err.message || 'Failed to save template';
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>
